module.exports = __webpack_public_path__ + "img/products.f5621749.png";